<div class="experience-scope portfolio-home" [attr.data-theme]="theme">
  <div class="pflist-wrap">
    <div class="pflist-hero">
      <div>
        <h1>
          {{ greeting }}@if (userName) {, {{ userName }} }
        </h1>
        <div class="lead">
          Here is what happened with your portfolios since your last visit.
        </div>
      </div>
      <div class="pflist-hero-right">
        <button
          type="button"
          class="btn btn-ghost"
          (click)="openUploadDialog()"
          [disabled]="isUploading"
        >
          Upload portfolio
        </button>
        <button
          [routerLink]="'portfolio-create/select'"
          (click)="onNewPortfolio()"
          type="button"
          class="btn btn-primary"
        >
          + New portfolio
        </button>
      </div>
    </div>

    <div class="pflist-stats">
      <div class="pflist-stat">
        <div class="lbl">Total portfolios</div>
        <div class="val">{{ all.length }}</div>
        <div class="sub">{{ starredCount }} starred</div>
      </div>
      <div
        class="pflist-stat"
        [class.pos]="totalDelta >= 0"
        [class.neg]="totalDelta < 0"
      >
        <div class="lbl">Avg annualised return</div>
        <div class="val">
          {{ totalDelta >= 0 ? "+" : "" }}{{ totalDelta | number: "1.1-1" }}%
        </div>
      </div>
      <div class="pflist-stat">
        <div class="lbl">Avg risk (vol)</div>
        <div class="val">{{ avgRisk | number: "1.1-1" }}%</div>
      </div>
      <div class="pflist-stat">
        <div class="lbl">Currencies</div>
        <div class="val">{{ currencies.length }}</div>
        <div class="sub">{{ currencies.join(" · ") || "—" }}</div>
      </div>
    </div>

    <div class="pflist-toolbar">
      <div class="pflist-search">
        <svg viewBox="0 0 24 24">
          <circle cx="11" cy="11" r="7" />
          <path d="M20 20l-3-3" />
        </svg>
        <input
          type="text"
          [(ngModel)]="search"
          (ngModelChange)="onSearch()"
          placeholder="Search by name…"
        />
      </div>
      <div class="pflist-filter-wrap" [class.open]="ccyFilterOpen">
        <button
          class="pflist-filter"
          type="button"
          (click)="toggleCurrencyFilter()"
          [class.active]="ccyFilter.size > 0"
        >
          <span>Currency · {{ currencyFilterLabel }}</span>
          <svg
            class="pflist-filter-caret"
            viewBox="0 0 12 12"
            aria-hidden="true"
          >
            <path
              d="M3 4.5l3 3 3-3"
              fill="none"
              stroke="currentColor"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </button>
        @if (ccyFilterOpen) {
          <div class="pflist-filter-menu">
            <div class="pflist-filter-menu-head">
              <span>Filter by currency</span>
              @if (ccyFilter.size) {
                <button
                  type="button"
                  class="pflist-filter-menu-clear"
                  (click)="clearCurrencyFilter()"
                >
                  Clear
                </button>
              }
            </div>
            <div class="pflist-filter-menu-list">
              @for (c of currencies; track c) {
                <label class="pflist-filter-option">
                  <input
                    type="checkbox"
                    [checked]="ccyFilter.has(c)"
                    (change)="toggleCurrencyOption(c)"
                  />
                  <span>{{ c }}</span>
                </label>
              }
              @if (!currencies.length) {
                <div class="pflist-filter-empty">No currencies available</div>
              }
            </div>
          </div>
        }
      </div>
      <button class="pflist-filter" type="button" (click)="cycleSort()">
        Sort · {{ sortLabel }}
      </button>
      <button
        class="pflist-filter"
        type="button"
        (click)="toggleFavouritesOnly()"
        [class.active]="favouritesOnly"
        [attr.aria-pressed]="favouritesOnly"
      >
        <svg
          class="pflist-filter-star"
          viewBox="0 0 24 24"
          [attr.fill]="favouritesOnly ? 'currentColor' : 'none'"
          stroke="currentColor"
          stroke-width="1.8"
          stroke-linejoin="round"
          aria-hidden="true"
        >
          <path
            d="M12 3l2.6 5.9 6.4.6-4.9 4.5 1.5 6.3L12 17l-5.6 3.3 1.5-6.3L3 9.5l6.4-.6z"
          />
        </svg>
        <span>Favourites</span>
      </button>
      <div class="pflist-view">
        <button
          type="button"
          [class.active]="view === 'cards'"
          (click)="setView('cards')"
        >
          Cards
        </button>
        <button
          type="button"
          [class.active]="view === 'list'"
          (click)="setView('list')"
        >
          List
        </button>
      </div>
    </div>

    @if (!isLoading && visible.length) {
      <div class="pflist-grid" [class.view-list]="view === 'list'">
        @for (p of visible; track trackByTile(i, p); let i = $index) {
          <a
            class="pf-tile"
            (click)="openPortfolio(p)"
            style="cursor: pointer"
            [style.--tile-i]="i"
          >
            <div class="pf-tile-head">
              <div class="pf-tile-head-main">
                <div class="pf-tile-name" [title]="p.name">{{ p.name }}</div>
                <div class="pf-tile-meta">
                  <span
                    class="pf-status"
                    [class.warn]="p.status === 'Computing'"
                    [class.neg]="p.status === 'Failed'"
                  >
                    <span class="dot"></span>{{ p.status }}
                  </span>
                  <span class="sep"></span>
                  <span>{{ p.ccy }}</span>
                  <span class="sep"></span>
                  <span>{{ p.assets }} assets</span>
                </div>
              </div>
              <div class="pf-tile-actions">
                <button
                  class="pf-tile-star"
                  type="button"
                  [class.on]="p.starred"
                  aria-label="Star"
                  (click)="toggleStar(p, $event)"
                >
                  <svg
                    viewBox="0 0 24 24"
                    [attr.fill]="p.starred ? 'currentColor' : 'none'"
                    stroke="currentColor"
                    stroke-width="1.8"
                    stroke-linejoin="round"
                  >
                    <path
                      d="M12 3l2.6 5.9 6.4.6-4.9 4.5 1.5 6.3L12 17l-5.6 3.3 1.5-6.3L3 9.5l6.4-.6z"
                    />
                  </svg>
                </button>
                <button
                  class="pf-tile-menu"
                  type="button"
                  mat-icon-button
                  aria-label="Portfolio actions"
                  [matMenuTriggerFor]="tileMenu"
                  (click)="$event.stopPropagation()"
                >
                  <mat-icon>more_vert</mat-icon>
                </button>
                <mat-menu #tileMenu="matMenu">
                  @if (!p.readonly) {
                    <button mat-menu-item (click)="onEdit(p, $event)">
                      Edit Portfolio
                    </button>
                  }
                  @if (p.readonly) {
                    <button mat-menu-item (click)="onView(p, $event)">
                      View
                    </button>
                  }
                  <button mat-menu-item (click)="onDuplicate(p, $event)">
                    Duplicate portfolio
                  </button>
                  <button mat-menu-item (click)="onClickInit(p, $event)">
                    Init
                  </button>
                  @if (!p.readonly) {
                    <button mat-menu-item (click)="onEditConstraints(p, $event)">
                      Edit constraints
                    </button>
                  }
                  <button mat-menu-item (click)="onExportPdf(p, $event)">
                    Export PDF
                  </button>
                  @if (!p.readonly) {
                    <button mat-menu-item (click)="deleteItem(p, $event)">
                      Delete
                    </button>
                  }
                  @if (p.readonly && p.visibility === sharedVisibility) {
                    <button mat-menu-item (click)="unshareItem(p, $event)">
                      Delete share
                    </button>
                  }
                </mat-menu>
              </div>
            </div>
            <div class="pf-tile-inline">
              <span>{{ p.ccy }}</span>
              <span>{{ p.assets }}a</span>
              <span>risk {{ p.risk | number: "1.1-1" }}%</span>
              <span>{{ p.updated }}</span>
            </div>
            <div class="pf-tile-body">
              <div
                class="pf-tile-spark"
                [class.is-loading]="p.isLoadingSeries"
              >
                @if (!p.isLoadingSeries) {
                  <app-sparkline
                    [data]="p.series"
                    [color]="colorFor(p)"
                    [width]="view === 'list' ? 120 : 200"
                    [height]="view === 'list' ? 24 : 36"
                  >
                  </app-sparkline>
                }
                @if (p.isLoadingSeries) {
                  <div
                    class="shimmer pf-tile-spark-skeleton"
                    [style.width.px]="view === 'list' ? 120 : 200"
                    [style.height.px]="view === 'list' ? 24 : 36"
                    aria-label="Loading chart"
                  ></div>
                }
              </div>
              <div class="pf-tile-delta" [class.neg]="p.delta < 0">
                {{ p.delta >= 0 ? "+" : "" }}{{ p.delta | number: "1.2-2" }}%
              </div>
            </div>
            <div class="pf-tile-foot">
              <div class="pf-tile-stat">
                <div class="lbl">Risk</div>
                <div class="val">{{ p.risk | number: "1.1-1" }}%</div>
              </div>
              <div class="pf-tile-stat">
                <div class="lbl">Created</div>
                <div class="val muted">{{ p.created }}</div>
              </div>
              <div class="pf-tile-stat">
                <div class="lbl">Updated</div>
                <div class="val muted">{{ p.updated }}</div>
              </div>
            </div>
          </a>
        }
      </div>
    }

    @if (!isLoading && hasMorePortfolios) {
      <div class="feed-load-more">
        <button
          type="button"
          class="feed-load-more-btn"
          (click)="onLoadMore()"
          [disabled]="isLoadingMore"
        >
          @if (!isLoadingMore) {
            <span>
              Load more portfolios
              <span class="feed-load-more-count"
                >({{ remainingPortfolioCount }} remaining)</span
              >
            </span>
          }
          @if (isLoadingMore) {
            <span>Loading…</span>
          }
        </button>
      </div>
    }

    @if (isLoading) {
      <div class="home-experience__state">
        <div
          class="shimmer"
          style="
            width: 100%;
            height: 120px;
            border-radius: 14px;
            margin-bottom: 10px;
          "
        ></div>
        <div
          class="shimmer"
          style="
            width: 100%;
            height: 120px;
            border-radius: 14px;
            margin-bottom: 10px;
          "
        ></div>
        <div
          class="shimmer"
          style="width: 100%; height: 120px; border-radius: 14px"
        ></div>
      </div>
    }

    @if (!isLoading && hasError) {
      <div class="home-experience__state home-experience__state--error">
        Couldn't load portfolios. Try again in a moment.
      </div>
    }

    @if (!isLoading && !hasError && !all.length) {
      <div class="home-experience__state">
        No portfolios yet. Create one to get started.
      </div>
    }

    @if (!isLoading && !hasError && all.length && !filtered.length) {
      <div class="home-experience__state">
        No portfolios match the current filters.
      </div>
    }
  </div>
</div>
